<template>
    <div class="content_box">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>发票导出</span>
                </div>
                <div class="title_desc">
                    输入订单号，选择 PDF 或 XLSX 直接下载发票。发票语言 / 币种 / 税率按订单自动处理（美国英文+分项税，德国德语，法国法语，其他国家英文）。
                </div>
            </div>

            <div class="export_card">
                <el-form label-width="90px" @submit.native.prevent>
                    <el-form-item label="订单号" required>
                        <el-input v-model="orderNo" placeholder="如 #NK-23297 / NK1023EU，或纯数字订单 ID"
                                  maxlength="40" clearable @keyup.enter.native="generate"
                                  style="max-width: 360px"></el-input>
                    </el-form-item>
                    <el-form-item label="导出格式">
                        <el-radio-group v-model="fileType">
                            <el-radio label="pdf">PDF</el-radio>
                            <el-radio label="xlsx">XLSX</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <div class="button button2" :class="{ disabled: generating }" @click="generate" v-if="canGenerate">
                            <i class="el-icon-download"></i>
                            <span>{{ generating ? '生成中…' : '生成并下载' }}</span>
                        </div>
                        <span class="form_tip" v-if="!canGenerate">当前账号无「生成发票」权限，请联系管理员</span>
                    </el-form-item>
                </el-form>
            </div>

            <div class="records_head" v-if="canViewRecords">
                <span class="records_title">最近开票记录</span>
                <div class="button text" @click="loadRecords">
                    <i class="el-icon-refresh"></i>
                    <span>刷新</span>
                </div>
            </div>
            <el-table v-if="canViewRecords" :data="records" v-loading="recordsLoading" stripe style="width: 100%">
                <el-table-column prop="order_name" label="订单号" width="150"></el-table-column>
                <el-table-column prop="shop_site" label="站点" width="130"></el-table-column>
                <el-table-column prop="country_code" label="国家" width="80"></el-table-column>
                <el-table-column label="计税" width="110">
                    <template slot-scope="scope">
                        <el-tag size="small" :type="modeTag(scope.row.tax_mode)">{{ modeText(scope.row.tax_mode) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="净额" width="110">
                    <template slot-scope="scope">{{ money(scope.row.net_total, scope.row.currency) }}</template>
                </el-table-column>
                <el-table-column label="税额" width="110">
                    <template slot-scope="scope">{{ money(scope.row.tax_total, scope.row.currency) }}</template>
                </el-table-column>
                <el-table-column label="总额" width="110">
                    <template slot-scope="scope">{{ money(scope.row.gross_total, scope.row.currency) }}</template>
                </el-table-column>
                <el-table-column prop="file_type" label="格式" width="80">
                    <template slot-scope="scope">{{ (scope.row.file_type || '').toUpperCase() }}</template>
                </el-table-column>
                <el-table-column prop="create_by" label="开票人" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="时间" min-width="160"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'invoice-export',
    data() {
        return {
            orderNo: '',
            fileType: 'pdf',
            generating: false,
            records: [],
            recordsLoading: false
        }
    },
    computed: {
        canGenerate() {
            return this.roleCheck('110-101-101-101')
        },
        canViewRecords() {
            return this.roleCheck('110-101-101-103')
        }
    },
    created() {
        this.loadRecords()
    },
    methods: {
        modeText(mode) {
            return { incl: '含税反算', excl: '价外税', none: '不含税' }[mode] || mode || '-'
        },
        modeTag(mode) {
            return { incl: 'warning', excl: 'success', none: 'info' }[mode] || 'info'
        },
        money(v, currency) {
            if (v === undefined || v === null || v === '') return '-'
            return `${v} ${currency || ''}`.trim()
        },
        generate() {
            if (this.generating) return
            const orderNo = (this.orderNo || '').trim()
            if (!orderNo) {
                this.$message.warning('请输入订单号')
                return
            }
            this.generating = true
            this.api.generateInvoice({ order_no: orderNo, type: this.fileType }).then(() => {
                this.generating = false
                // 下载由 http 封装触发，稍后刷新记录
                setTimeout(() => this.loadRecords(), 500)
            }).catch(() => {
                this.generating = false
            })
        },
        loadRecords() {
            if (!this.canViewRecords) return
            this.recordsLoading = true
            this.api.listInvoiceRecord({ page: 1, page_size: 20 }).then(res => {
                if (res && res.code === 200 && res.data) {
                    this.records = res.data.list || []
                } else {
                    this.records = []
                }
                this.recordsLoading = false
            }).catch(() => {
                this.records = []
                this.recordsLoading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .title_desc {
        margin-top: 8px;
        color: #999;
        font-size: 13px;
        line-height: 1.6;
    }
    .export_card {
        background: #fff;
        border: 1px solid #E8E9F1;
        border-radius: 10px;
        padding: 24px 24px 6px;
        margin-bottom: 24px;
    }
    .form_tip {
        color: #999;
        font-size: 12px;
        margin-left: 12px;
    }
    .records_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        .records_title {
            font-size: 15px;
            font-weight: 600;
            color: #333;
        }
    }
    .button.disabled {
        opacity: .6;
        pointer-events: none;
    }
</style>


// WEBPACK FOOTER //
// src/view/invoice/export.vue